import { useLocation, useNavigate } from 'react-router-dom';
import { Box, SpaceBetween } from '@cloudscape-design/components';
import TemplateDetails from 'src/components/template/TemplateDetails';
import { useEffect, useState } from 'react';
import TemplateForm from 'src/components/template/TemplateForm';
import { useTemplates } from 'src/store/templates/useTemplates';
import TableSchedules from 'src/components/schedule/TableSchedules';
import { useBusinessUnit } from 'src/store/businessUnit/useBusinessUnit';
import { useUserDetails } from 'src/providers/UserProvider';

const TemplateDetailsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentTemplate, selectCurrentTemplate } = useTemplates();
  const { businessUnitList } = useBusinessUnit();
  const { permissions } = useUserDetails();

  const [isEditMode, setEditMode] = useState(location.state.data ? false : true);

  const isEditTemplate = permissions.has('EditTemplate');

  useEffect(() => {
    selectCurrentTemplate(location.state.data);
    return () => {
      selectCurrentTemplate(undefined);
    };
  }, []);

  return (
    <Box margin={{ top: 's' }}>
      <SpaceBetween direction="vertical" size="s">
        {!isEditMode ? (
          <TemplateDetails
            data-testid="template-details"
            template={currentTemplate}
            isEditTemplate={isEditTemplate}
            businessUnitList={businessUnitList}
            onEditClick={() => {
              setEditMode(true);
            }}
          />
        ) : (
          <TemplateForm
            data-testid="template-form"
            auditTemplate={currentTemplate}
            dismissView={() => {
              if (currentTemplate) {
                setEditMode(false);
              } else {
                navigate(-1);
              }
            }}
          />
        )}

        {currentTemplate && !isEditMode && (
          <TableSchedules templateId={currentTemplate?.id} />
        )}
      </SpaceBetween>
    </Box>
  );
};

export default TemplateDetailsPage;
